import {
  FETCH_SIGNUP_PENDING,
  FETCH_SIGNUP_REJECTED,
  FETCH_SIGNUP_FULFILLED,
  SIGNUP_SMS_VERIFICATION_FORM_SHOW,
  SIGNUP_SMS_VERIFICATION_FORM_HIDE,
  CLEAR_SIGNUP_STATE,
} from '../constants/signup';

const initialState = {
  status: 0,
  pending: false,
  smsModalVisibility: false,
  error: {},
};

export const signup = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SIGNUP_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_SIGNUP_REJECTED:
      const {
        email,
        firstName,
        lastName,
        phone,
        password,
        confirm,
        dateOfBirth,
        verificationCode,
        apiError,
        gender,
        tomPayAllowed,
        detail
      } = action.data || {};

      return {
        ...state,
        pending: false,
        error: {
          email,
          phone,
          confirm,
          password,
          first_name: firstName,
          last_name: lastName,
          date_of_birth: dateOfBirth,
          code: verificationCode,
          api_error: apiError,
          gender,
          tom_pay_allowed: tomPayAllowed,
          detail
        },
      };

    case FETCH_SIGNUP_FULFILLED:
      return {
        ...state,
        status: action.data.status,
        pending: false,
        error: {},
      };

    case SIGNUP_SMS_VERIFICATION_FORM_SHOW:
      return {
        ...state,
        smsModalVisibility: true,
        error: {},
      };

    case SIGNUP_SMS_VERIFICATION_FORM_HIDE:
      return {
        ...state,
        status: 0,
        smsModalVisibility: false,
        pending: false,
        error: {},
      };

    case CLEAR_SIGNUP_STATE:
      return {
        status: 0,
        pending: false,
        smsModalVisibility: false,
        error: {},
      }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/signup.js